import React from 'react';

import classNames from 'classnames';

const SectionContainer = ({
    title,
    description,
    renderButton,
    isEditable = true,
    paddingClassName = null,
    marginClassName = null,
    variant = 'primary', // primary | secondary
    children,
}) => {
    const containerClassName = classNames(
        'w-full bg-white rounded-2xl',
        paddingClassName || {
            'p-4 sm:p-5 md:p-6': variant === 'primary',
            'p-4 sm:p-5': variant === 'secondary',
        }
    );

    const headerContainerClassName = classNames(
        isEditable && 'flex flex-col xs:flex-row items-start justify-between gap-x-4 gap-y-2',
        marginClassName || { 'mb-6': variant === 'primary', 'mb-5': variant === 'secondary' }
    );

    const titleClassName = classNames('font-heading-bold text-black', !!description && 'mb-2', {
        'text-heading-bold-m': variant === 'primary',
        'text-heading-bold-s': variant === 'secondary',
    });
    const descriptionClassName = classNames('font-body text-body-regular-s whitespace-pre-wrap', {
        'text-neutral-300': variant === 'primary',
        'text-neutral-500': variant === 'secondary',
    });

    return (
        <div className={containerClassName}>
            <div className={headerContainerClassName}>
                <div>
                    <p className={titleClassName}>{title}</p>
                    {description && <p className={descriptionClassName}>{description}</p>}
                </div>

                {isEditable && renderButton?.()}
            </div>

            {children}
        </div>
    );
};

export default SectionContainer;
